import { inject, injectable } from "tsyringe";
import { CardProtectionExclusion } from "src/containers/card-protection/domain/exclusion";
import { cardProtectionPlusGroupCodes } from "src/containers/card-protection/core/constants";
import plusExclusions from "src/containers/card-protection/core/data/exclusions-plus";
import baseExclusions from "src/containers/card-protection/core/data/exclusions-base";
import { autoBind } from "src/shared/decorators/autobind";

type Exclusion = {
    id: string;
    icon: JSX.Element;
    text: string;
    shouldRedirect?: boolean;
};

@injectable()
export class CardProtectionExclusionViewModel {
    private isPlus: boolean;

    constructor(@inject("GroupCode") groupCode: string) {
        const plusGroupCodes = cardProtectionPlusGroupCodes;

        this.isPlus = plusGroupCodes.includes(groupCode);
    }

    @autoBind
    private getExclusions(): CardProtectionExclusion[] {
        return this.isPlus ? plusExclusions : baseExclusions;
    }

    @autoBind
    getExclusionsList(): Exclusion[] {
        return this.getExclusions().map(
            ({ icon, shortTitle, id, content }) => ({
                id,
                icon: icon,
                text: shortTitle,
                shouldRedirect: !!content,
            })
        );
    }

    getExclusion = (
        exclusionId: string
    ): CardProtectionExclusion | undefined => {
        return this.getExclusions().find((e) => e.id === exclusionId);
    };
}
